/**
 * EffectiveDate — the dateline every published policy page carries.
 *
 * One component rather than three so the three pages cannot drift in wording
 * or placement, and so scripts/check-legal-effective-date.mjs has a single
 * thing to look for. The date itself comes from src/config/legalVersions.ts.
 *
 * Rendered as a <time> with a machine-readable dateTime, which is what a
 * screen reader and a crawler both want, and which costs nothing here.
 */
import React from 'react';
import styled from 'styled-components';
import {
  LEGAL_VERSIONS,
  effectiveDateLabel,
  type LegalDocumentKey,
} from '../../config/legalVersions';

const Dateline = styled.time`
  display: block;
  text-align: center;
  position: relative;
  z-index: 2;
  font-size: 0.82rem;
  font-weight: 500;
  letter-spacing: 0.04em;
  /* Against the dark policy hero. 0.78 alpha on --brand-canvas keeps this
     above 4.5:1 while staying visibly secondary to the title. */
  color: color-mix(in srgb, var(--brand-canvas) 78%, transparent);
`;

export const EffectiveDate: React.FC<{ document: LegalDocumentKey }> = ({ document: key }) => (
  <Dateline dateTime={LEGAL_VERSIONS[key].effectiveDate}>
    {effectiveDateLabel(key)}
  </Dateline>
);

export default EffectiveDate;
